import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default function NovaSolicitacao() {
    const [aceitouTermos, setAceitouTermos] = useState(false);
    const [captchaToken, setCaptchaToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [cidadeSelecionada, setCidadeSelecionada] = useState('3156|RECIFE');
    const [estadoSelecionado, setEstadoSelecionado] = useState('PE');
    const formRef = useRef(null);

    const handleSubmit = () => {
        if (!aceitouTermos || !captchaToken) return;
        setLoading(true);
        formRef.current.submit();
    };

    return (
        <Row>
            <Col xs="12">
                <Col xs="12">
                    <p>
                        <small>
                            Você está em{' '}
                            <a href="/ouvidoria">
                                SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA
                            </a>{' '}
                            / Nova Solicitação
                        </small>
                    </p>
                </Col>
                <h1>Nova Solicitação</h1>
                <article className="wrapper-three-col three-col article">
                    <Form
                        action="https://www.alepe.pe.gov.br/servicos/emailv2/_modeloSic4.php"
                        className="sic"
                        method="post"
                        id="formulario"
                        encType="multipart/form-data"
                        acceptCharset="UTF-8"
                        ref={formRef}
                    >
                        <Row>
                        <Col md="6">
                            <Form.Group controlId="assunto">
                                <Form.Label>Assunto:*</Form.Label>
                                <Form.Control as="select" name="assunto">
                                    <option value="6">DENÚNCIA</option>
                                    <option value="7">ELOGIO</option>
                                    <option value="8">PEDIDO DE INFORMAÇÃO / DOCUMENTAÇÃO</option>
                                    <option value="9">SOLICITAÇÃO</option>
                                    <option value="10">SUGESTÃO</option>
                                    <option value="11">OUTROS</option>
                                    <option value="12">RECLAMAÇÃO</option>
                                    <option value="13">CRÍTICA</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group controlId="tipoidentificacao">
                                <Form.Label>Tipo de identificação:*</Form.Label>
                                <Form.Control as="select" name="tipoidentificacao">
                                    <option value="idokdivulgaok">Desejo me identificar e autorizo divulgação</option>
                                    <option value="idokdivulganok">Desejo me identificar mas solicito proteção de dados pessoais</option>
                                    <option value="idnok">Não desejo me identificar</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <Form.Group controlId="nome">
                                <Form.Label>Nome:*</Form.Label>
                                <Form.Control type="text" name="nome" />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group>
                                <Form.Label>Documento:*</Form.Label>
                                <Form.Control as="select" name="documento">
                                    <option value="CPF">CPF</option>
                                    <option value="CNPJ">CNPJ</option>
                                    <option value="RG">RG</option>
                                    <option value="CNH">CNH</option>
                                    <option value="PASSAPORTE">PASSAPORTE</option>
                                    <option value="OUTROS">OUTROS</option>
                                </Form.Control>

                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group>
                                <Form.Label>Número do documento:*</Form.Label>
                                <Form.Control type="text" name="numeroDocumento" />
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <Form.Group controlId="endereco">
                                <Form.Label>Endereço:</Form.Label>
                                <Form.Control type="text" name="endereco" />
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Col md={6}>
                                    <Form.Label>Número:</Form.Label>
                                    <Form.Control type="text" name="enderecoNumero" id="enderecoNumero" />
                                </Col>
                                <Col md={6}>
                                    <Form.Label>Complemento:</Form.Label>
                                    <Form.Control type="text" name="enderecoComplemento" className="inputComplete" />
                                </Col>
                            </Form.Group>

                            <Form.Group controlId="enderecoBairro">
                                <Form.Label>Bairro:</Form.Label>
                                <Form.Control type="text" name="enderecoBairro" />
                            </Form.Group>

                            <Form.Group as={Row}>
                                <Col md={6}>
                                    <Form.Label>Cidade:</Form.Label>
                                    {estadoSelecionado === "PE" ? <Form.Control as="select" name="enderecoCidade" onChange={(e) => setCidadeSelecionada(e.target.value)} value={cidadeSelecionada} id="select_cidade">
                                        <option value="241|ABREU E LIMA">ABREU E LIMA</option>
                                        <option value="2853|AFOGADOS DA INGAZEIRA">AFOGADOS DA INGAZEIRA</option>
                                        <option value="2854|AFRÂNIO">AFRÂNIO</option>
                                        <option value="2855|AGRESTINA">AGRESTINA</option>
                                        <option value="2856|ÁGUA PRETA">ÁGUA PRETA</option>
                                        <option value="2857|ÁGUAS BELAS">ÁGUAS BELAS</option>
                                        <option value="2858|ALAGOINHA">ALAGOINHA</option>
                                        <option value="2859|ALIANÇA">ALIANÇA</option>
                                        <option value="2860|ALTINHO">ALTINHO</option>
                                        <option value="2861|AMARAJI">AMARAJI</option>
                                        <option value="2862|ANGELIM">ANGELIM</option>
                                        <option value="2863|ARAÇOIABA">ARAÇOIABA</option>
                                        <option value="2864|ARARIPINA">ARARIPINA</option>
                                        <option value="2865|ARCOVERDE">ARCOVERDE</option>
                                        <option value="2866|BARRA DE GUABIRABA">BARRA DE GUABIRABA</option>
                                        <option value="2867|BARREIROS">BARREIROS</option>
                                        <option value="2868|BELÉM DE MARIA">BELÉM DE MARIA</option>
                                        <option value="2869|BELÉM DE SÃO FRANCISCO">BELÉM DE SÃO FRANCISCO</option>
                                        <option value="2870|BELO JARDIM">BELO JARDIM</option>
                                        <option value="2871|BETÂNIA">BETÂNIA</option>
                                        <option value="2872|BEZERROS">BEZERROS</option>
                                        <option value="2873|BODOCÓ">BODOCÓ</option>
                                        <option value="2874|BOM CONSELHO">BOM CONSELHO</option>
                                        <option value="2875|BOM JARDIM">BOM JARDIM</option>
                                        <option value="2876|BONITO">BONITO</option>
                                        <option value="2877|BREJÃO">BREJÃO</option>
                                        <option value="2878|BREJINHO">BREJINHO</option>
                                        <option value="2879|BREJO DA MADRE DE DEUS">BREJO DA MADRE DE DEUS</option>
                                        <option value="2880|BUENOS AIRES">BUENOS AIRES</option>
                                        <option value="2881|BUÍQUE">BUÍQUE</option>
                                        <option value="2882|CABO DE SANTO AGOSTINHO">CABO DE SANTO AGOSTINHO</option>
                                        <option value="2883|CABROBÓ">CABROBÓ</option>
                                        <option value="2884|CACHOEIRINHA">CACHOEIRINHA</option>
                                        <option value="2885|CAETÉS">CAETÉS</option>
                                        <option value="2886|CALÇADO">CALÇADO</option>
                                        <option value="2887|CALUMBI">CALUMBI</option>
                                        <option value="242|CAMARAGIBE">CAMARAGIBE</option>
                                        <option value="937|CAMOCIM DE SÃO FÉLIX">CAMOCIM DE SÃO FÉLIX</option>
                                        <option value="938|CAMUTANGA">CAMUTANGA</option>
                                        <option value="939|CANHOTINHO">CANHOTINHO</option>
                                        <option value="480|CAPOEIRAS">CAPOEIRAS</option>
                                        <option value="672|CARNAÍBA">CARNAÍBA</option>
                                        <option value="1473|CARNAUBEIRA DA PENHA">CARNAUBEIRA DA PENHA</option>
                                        <option value="2982|CARPINA">CARPINA</option>
                                        <option value="2983|CARUARU">CARUARU</option>
                                        <option value="2984|CASINHAS">CASINHAS</option>
                                        <option value="2985|CATENDE">CATENDE</option>
                                        <option value="2986|CEDRO">CEDRO</option>
                                        <option value="2987|CHÃ DE ALEGRIA">CHÃ DE ALEGRIA</option>
                                        <option value="2988|CHÃ GRANDE">CHÃ GRANDE</option>
                                        <option value="2989|CONDADO">CONDADO</option>
                                        <option value="2990|CORRENTES">CORRENTES</option>
                                        <option value="2991|CORTÊS">CORTÊS</option>
                                        <option value="2992|CUMARU">CUMARU</option>
                                        <option value="2993|CUPIRA">CUPIRA</option>
                                        <option value="2994|CUSTÓDIA">CUSTÓDIA</option>
                                        <option value="2995|DORMENTES">DORMENTES</option>
                                        <option value="2996|ESCADA">ESCADA</option>
                                        <option value="2997|EXU">EXU</option>
                                        <option value="2998|FEIRA NOVA">FEIRA NOVA</option>
                                        <option value="2999|FERNANDO DE NORONHA">FERNANDO DE NORONHA</option>
                                        <option value="3000|FERREIROS">FERREIROS</option>
                                        <option value="3001|FLORES">FLORES</option>
                                        <option value="3002|FLORESTA">FLORESTA</option>
                                        <option value="3003|FREI MIGUELINHO">FREI MIGUELINHO</option>
                                        <option value="3004|GAMELEIRA">GAMELEIRA</option>
                                        <option value="3005|GARANHUNS">GARANHUNS</option>
                                        <option value="3006|GLÓRIA DO GOITÁ">GLÓRIA DO GOITÁ</option>
                                        <option value="3007|GOIANA">GOIANA</option>
                                        <option value="3008|GRANITO">GRANITO</option>
                                        <option value="3009|GRAVATÁ">GRAVATÁ</option>
                                        <option value="3010|IATI">IATI</option>
                                        <option value="3011|IBIMIRIM">IBIMIRIM</option>
                                        <option value="3012|IBIRAJUBA">IBIRAJUBA</option>
                                        <option value="3013|IGARASSU">IGARASSU</option>
                                        <option value="3014|IGUARACI">IGUARACI</option>
                                        <option value="3015|INAJÁ">INAJÁ</option>
                                        <option value="3016|INGAZEIRA">INGAZEIRA</option>
                                        <option value="3017|IPOJUCA">IPOJUCA</option>
                                        <option value="3018|IPUBI">IPUBI</option>
                                        <option value="3019|ITACURUBA">ITACURUBA</option>
                                        <option value="3020|ITAÍBA">ITAÍBA</option>
                                        <option value="3021|ITAMARACÁ">ITAMARACÁ</option>
                                        <option value="3022|ITAMBÉ">ITAMBÉ</option>
                                        <option value="3023|ITAPETIM">ITAPETIM</option>
                                        <option value="3024|ITAPISSUMA">ITAPISSUMA</option>
                                        <option value="3025|ITAQUITINGA">ITAQUITINGA</option>
                                        <option value="3026|JABOATÃO DOS GUARARAPES">JABOATÃO DOS GUARARAPES</option>
                                        <option value="3027|JAQUEIRA">JAQUEIRA</option>
                                        <option value="3028|JATAÚBA">JATAÚBA</option>
                                        <option value="3029|JATOBÁ">JATOBÁ</option>
                                        <option value="3030|JOÃO ALFREDO">JOÃO ALFREDO</option>
                                        <option value="3031|JOAQUIM NABUCO">JOAQUIM NABUCO</option>
                                        <option value="3032|JUCATI">JUCATI</option>
                                        <option value="3033|JUPI">JUPI</option>
                                        <option value="3034|JUREMA">JUREMA</option>
                                        <option value="3035|LAGOA DO CARRO">LAGOA DO CARRO</option>
                                        <option value="673|LAGOA DO ITAENGA">LAGOA DO ITAENGA</option>
                                        <option value="674|LAGOA DO OURO">LAGOA DO OURO</option>
                                        <option value="675|LAGOA DOS GATOS">LAGOA DOS GATOS</option>
                                        <option value="676|LAGOA GRANDE">LAGOA GRANDE</option>
                                        <option value="677|LAJEDO">LAJEDO</option>
                                        <option value="678|LIMOEIRO">LIMOEIRO</option>
                                        <option value="679|MACAPARANA">MACAPARANA</option>
                                        <option value="680|MACHADOS">MACHADOS</option>
                                        <option value="681|MANARI">MANARI</option>
                                        <option value="682|MARAIAL">MARAIAL</option>
                                        <option value="683|MIRANDIBA">MIRANDIBA</option>
                                        <option value="684|MOREILÂNDIA">MOREILÂNDIA</option>
                                        <option value="685|MORENO">MORENO</option>
                                        <option value="686|NAZARÉ DA MATA">NAZARÉ DA MATA</option>
                                        <option value="687|OLINDA">OLINDA</option>
                                        <option value="688|OROBÓ">OROBÓ</option>
                                        <option value="689|OROCÓ">OROCÓ</option>
                                        <option value="690|OURICURI">OURICURI</option>
                                        <option value="691|PALMARES">PALMARES</option>
                                        <option value="3140|PALMEIRINA">PALMEIRINA</option>
                                        <option value="3141|PANELAS">PANELAS</option>
                                        <option value="3142|PARANATAMA">PARANATAMA</option>
                                        <option value="3143|PARNAMIRIM">PARNAMIRIM</option>
                                        <option value="3144|PASSIRA">PASSIRA</option>
                                        <option value="3145|PAUDALHO">PAUDALHO</option>
                                        <option value="3146|PAULISTA">PAULISTA</option>
                                        <option value="3147|PEDRA">PEDRA</option>
                                        <option value="3148|PESQUEIRA">PESQUEIRA</option>
                                        <option value="3149|PETROLÂNDIA">PETROLÂNDIA</option>
                                        <option value="3150|PETROLINA">PETROLINA</option>
                                        <option value="3151|POÇÃO">POÇÃO</option>
                                        <option value="3152|POMBOS">POMBOS</option>
                                        <option value="3153|PRIMAVERA">PRIMAVERA</option>
                                        <option value="3154|QUIPAPÁ">QUIPAPÁ</option>
                                        <option value="3155|QUIXABA">QUIXABA</option>
                                        <option value="3156|RECIFE">RECIFE</option>
                                        <option value="3157|RIACHO DAS ALMAS">RIACHO DAS ALMAS</option>
                                        <option value="3158|RIBEIRÃO">RIBEIRÃO</option>
                                        <option value="3159|RIO FORMOSO">RIO FORMOSO</option>
                                        <option value="3160|SAIRÉ">SAIRÉ</option>
                                        <option value="3161|SALGADINHO">SALGADINHO</option>
                                        <option value="3162|SALGUEIRO">SALGUEIRO</option>
                                        <option value="3163|SALOÁ">SALOÁ</option>
                                        <option value="3164|SANHARÓ">SANHARÓ</option>
                                        <option value="3165|SANTA CRUZ">SANTA CRUZ</option>
                                        <option value="3166|SANTA CRUZ DA BAIXA VERDE">SANTA CRUZ DA BAIXA VERDE</option>
                                        <option value="3167|SANTA CRUZ DO CAPIBARIBE">SANTA CRUZ DO CAPIBARIBE</option>
                                        <option value="3168|SANTA FILOMENA">SANTA FILOMENA</option>
                                        <option value="3169|SANTA MARIA DA BOA VISTA">SANTA MARIA DA BOA VISTA</option>
                                        <option value="3170|SANTA MARIA DO CAMBUCÁ">SANTA MARIA DO CAMBUCÁ</option>
                                        <option value="3171|SANTA TEREZINHA">SANTA TEREZINHA</option>
                                        <option value="3172|SÃO BENEDITO DO SUL">SÃO BENEDITO DO SUL</option>
                                        <option value="3173|SÃO BENTO DO UNA">SÃO BENTO DO UNA</option>
                                        <option value="3174|SÃO CAITANO">SÃO CAITANO</option>
                                        <option value="3175|SÃO JOÃO">SÃO JOÃO</option>
                                        <option value="3176|SÃO JOAQUIM DO MONTE">SÃO JOAQUIM DO MONTE</option>
                                        <option value="3177|SÃO JOSÉ DA COROA GRANDE">SÃO JOSÉ DA COROA GRANDE</option>
                                        <option value="3178|SÃO JOSÉ DO BELMONTE">SÃO JOSÉ DO BELMONTE</option>
                                        <option value="3179|SÃO JOSÉ DO EGITO">SÃO JOSÉ DO EGITO</option>
                                        <option value="3180|SÃO LOURENÇO DA MATA">SÃO LOURENÇO DA MATA</option>
                                        <option value="3181|SÃO VICENTE FERRER">SÃO VICENTE FERRER</option>
                                        <option value="3182|SERRA TALHADA">SERRA TALHADA</option>
                                        <option value="3183|SERRITA">SERRITA</option>
                                        <option value="3184|SERTÂNIA">SERTÂNIA</option>
                                        <option value="3185|SIRINHAÉM">SIRINHAÉM</option>
                                        <option value="3186|SOLIDÃO">SOLIDÃO</option>
                                        <option value="3187|SURUBIM">SURUBIM</option>
                                        <option value="3188|TABIRA">TABIRA</option>
                                        <option value="3189|TACAIMBÓ">TACAIMBÓ</option>
                                        <option value="3190|TACARATU">TACARATU</option>
                                        <option value="3191|TAMANDARÉ">TAMANDARÉ</option>
                                        <option value="3192|TAQUARITINGA DO NORTE">TAQUARITINGA DO NORTE</option>
                                        <option value="3193|TEREZINHA">TEREZINHA</option>
                                        <option value="1090|TERRA NOVA">TERRA NOVA</option>
                                        <option value="1091|TIMBAÚBA">TIMBAÚBA</option>
                                        <option value="1092|TORITAMA">TORITAMA</option>
                                        <option value="1093|TRACUNHAÉM">TRACUNHAÉM</option>
                                        <option value="1094|TRINDADE">TRINDADE</option>
                                        <option value="1095|TRIUNFO">TRIUNFO</option>
                                        <option value="1096|TUPANATINGA">TUPANATINGA</option>
                                        <option value="1097|TUPARETAMA">TUPARETAMA</option>
                                        <option value="1098|VENTUROSA">VENTUROSA</option>
                                        <option value="1099|VERDEJANTE">VERDEJANTE</option>
                                        <option value="1100|VERTENTE DO LÉRIO">VERTENTE DO LÉRIO</option>
                                        <option value="1101|VERTENTES">VERTENTES</option>
                                        <option value="1102|VICÊNCIA">VICÊNCIA</option>
                                        <option value="1103|VITÓRIA DE SANTO ANTÃO">VITÓRIA DE SANTO ANTÃO</option>
                                        <option value="1104|XEXÉU">XEXÉU</option>
                                    </Form.Control> : <Form.Control type="text" name="enderecoCidade" /> }
                                </Col>
                                <Col md={6}>
                                    <Form.Label>UF:</Form.Label>
                                    <Form.Control as="select" name="enderecoEstado" onChange={(e) => setEstadoSelecionado(e.target.value)} value={estadoSelecionado} id="select_estado">
                                        <option value="AC">AC</option>
                                        <option value="AL">AL</option>
                                        <option value="AM">AM</option>
                                        <option value="AP">AP</option>
                                        <option value="BA">BA</option>
                                        <option value="CE">CE</option>
                                        <option value="DF">DF</option>
                                        <option value="ES">ES</option>
                                        <option value="GO">GO</option>
                                        <option value="MA">MA</option>
                                        <option value="MG">MG</option>
                                        <option value="MS">MS</option>
                                        <option value="MT">MT</option>
                                        <option value="PA">PA</option>
                                        <option value="PB">PB</option>
                                        <option value="PE">PE</option>
                                        <option value="PI">PI</option>
                                        <option value="PR">PR</option>
                                        <option value="RJ">RJ</option>
                                        <option value="RN">RN</option>
                                        <option value="RS">RS</option>
                                        <option value="RO">RO</option>
                                        <option value="PR">RR</option>
                                        <option value="SC">SC</option>
                                        <option value="SE">SE</option>
                                        <option value="SP">SP</option>
                                        <option value="TO">TO</option>
                                    </Form.Control>
                                </Col>
                            </Form.Group>

                            <Form.Group controlId="enderecoCep">
                                <Form.Label>CEP:</Form.Label>
                                <Form.Control type="text" name="enderecoCep" />
                            </Form.Group>

                            <Form.Group controlId="email">
                                <Form.Label>Email:*</Form.Label>
                                <Form.Control type="email" name="email" />
                            </Form.Group>

                            <Form.Group controlId="telefone">
                                <Form.Label>Telefone:*</Form.Label>
                                <Form.Control type="tel" name="telefone" />
                            </Form.Group>

                            <Form.Group controlId="texto">
                                <Form.Label>Mensagem:*</Form.Label>
                                <Form.Control as="textarea" name="texto" className="inputMsg" rows={6} />
                            </Form.Group>

                            <Form.Group controlId="anexos">
                                <Form.Label>Documentos:</Form.Label>
                                <Form.Control type="file" multiple name="anexos[]" accept="image/png, image/jpeg" />
                            </Form.Group>
                            </Col>
                            <Col xs="12">
                                <Form.Group controlId="concordoTermos">
                                    <Form.Check
                                        type="checkbox"
                                        onChange={e => setAceitouTermos(e.target.checked)}
                                        label="Concordo com os Termos de Uso"
                                    />
                                </Form.Group>
                            </Col>

                            <Col xs="12" className="mb-3">
                                <ReCAPTCHA
                                    sitekey="6Lcxsy4rAAAAADvzREDxnCORnoCW5p6tC85fVlxn"
                                    onChange={token => setCaptchaToken(token || '')}
                                />
                                {/* envia o token junto com o formulário */}
                                <input
                                    type="hidden"
                                    name="g-recaptcha-response"
                                    value={captchaToken}
                                />
                            </Col>

                            <Col xs="12" className="text-end">
                                {loading ? (
                                    <Spinner />
                                ) : (
                                    <Button
                                        variant="primary"
                                        onClick={handleSubmit}
                                        disabled={!aceitouTermos || !captchaToken}
                                        type="button"
                                    >
                                        Enviar
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </Form>
                </article>
            </Col>

            {/* -------- texto institucional -------- */}
            <Col sm={12}>
                <h5>SIC - SERVIÇO DE INFORMAÇÃO AO CIDADÃO</h5>
                <p>Setor responsável: Ouvidoria</p>
                <p>Deseja fazer o pedido de acesso à informação presencialmente?</p>
                <p>
                    É só dirigir-se ao endereço físico do SIC da Assembleia Legislativa de
                    Pernambuco:
                </p>

                <p>
                    Endereço: Rua da União, 397, Boa Vista, Recife-PE, Anexo I, 6º Andar,
                    Sala 603.
                    <br />
                    CEP: 50050-909
                    <br />
                    Fone: (81) 3183-2211
                    <br />
                    Ramal: 2003
                    <br />
                    E-mail: ouvidoria@alepe.pe.gov.br
                </p>

                <p>
                    Horário de funcionamento: De segunda a quinta das 8h às 12h e das 14h
                    às 18h e nas sextas das 8h às 13h
                </p>
            </Col>
            <Col sm={12} className="mt-4">
                <h5>LEGISLAÇÃO</h5>
                <ul>
                    <li>
                        <a
                            href="https://legis.alepe.pe.gov.br/texto.aspx?id=4481&tipo="
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Lei nº 15.224, de 26 de dezembro de 2013 – Lei de Acesso à Informação da Alepe
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.planalto.gov.br/ccivil_03/_ato2011-2014/2011/lei/l12527.htm"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Lei nº 12.527, de 18 de novembro de 2011 – Lei de Acesso à Informação Federal
                        </a>
                    </li>
                </ul>
            </Col>

            <Col sm={12} className="mt-4">
                <h5>Qual o prazo para receber a resposta para os pedidos de informação?</h5>
                <p>
                    O prazo para resposta de pedido de acesso à informação é de 20 (vinte) dias,
                    prorrogável por mais 10 (dez) dias, mediante justificativa. Já para o tratamento de
                    denúncias e reclamações, a Lei Federal nº 13.460/2017 estabelece prazo de até 30
                    (trinta) dias, prorrogável uma única vez por igual período, desde que devidamente
                    justificado.
                </p>
                <p>
                    Caso não seja possível atendê-lo dentro deste prazo, a ouvidoria deverá informar sobre os
                    encaminhamentos, as etapas e os prazos previstos para uma resposta conclusiva, ou
                    solicitar informações adicionais.
                </p>
                <p>
                    Os pedidos de informação apresentados entre 17h e 23h59 serão considerados como se
                    tivessem sido realizados no dia útil seguinte, e a contagem do prazo começará a partir
                    do primeiro dia útil posterior.
                </p>
                <p>
                    Quando o prazo final coincidir com final de semana ou feriado, será automaticamente
                    prorrogado para o próximo dia útil. Por isso, o prazo de resposta pode não ser sempre
                    exatamente de 20 dias corridos.
                </p>
            </Col>

            <Col sm={12} className="mt-4">
                <h5>Quais as autoridades competentes para responder a minha manifestação?</h5>
                <ul>
                    <li>
                        Os pedidos serão encaminhados à Presidência e distribuídos aos Parlamentares, Comissões Parlamentares ou Setores Administrativos da Alepe para resposta, conforme o assunto seja da sua competência.
                    </li>
                </ul>
            </Col>

            <Col sm={12} className="mt-3">
                <h5>Caso não esteja satisfeito com a resposta à minha manifestação, posso recorrer?</h5>
                <p>
                    Sim. É possível apresentar Recurso conforme Lei de Acesso à Informação que será distribuído à Ouvidoria para apreciação pelo Ouvidor-Geral e para a Mesa Diretora da Alepe para deliberação e resposta, conforme art. 15 da Lei no. 15.224/2013.
                </p>
            </Col>

            <Col sm={12} className="mt-3">
                <h5>Atenção!</h5>
                <ul>
                    <li>
                        Todos os procedimentos relativos a formalização do pedido e eventual recurso estão previstos na Lei 15.224/2013 e na nossa{' '}
                        <a
                            href="https://www.alepe.pe.gov.br/servicos/showPdf.php?arquivo=/wp-content/uploads/2019/08/carta-de-servico-02-2019.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#20579f', textDecoration: 'underline' }}
                        >
                            Carta de Serviços
                        </a>
                        , ambos disponíveis para consulta na página de transparência e página oficial da Alepe.
                    </li>
                </ul>
            </Col>

        </Row>
    );
}
